import { useEffect } from 'react';

/**
 * Trava o scroll do body enquanto um modal está aberto — sem isso, a página
 * por trás rola junto com o conteúdo do modal, dando a impressão de duas
 * barras de rolagem simultâneas.
 *
 * `isOpen` é opcional: componentes que só existem no DOM enquanto abertos
 * (montados condicionalmente pelo pai) podem chamar sem argumento; os que
 * ficam sempre montados e controlam visibilidade internamente (com um early
 * `return null`) devem passar o próprio `isOpen`, chamando o hook ANTES
 * desse return (regra dos hooks: sempre na mesma ordem, nunca depois de um
 * retorno condicional).
 */
export function useBodyScrollLock(isOpen = true) {
  useEffect(() => {
    if (!isOpen) return undefined;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
}
